module.exports = __webpack_public_path__ + "img/stop.fa5d20a4.svg";